import { createElement, Fragment, memo, useReducer } from 'react';
import { NavLink } from 'react-router-dom';

import clsx from 'clsx';
import { useAtomValue } from 'jotai';
import { Menu } from 'lucide-react';
import { isNonNullish } from 'remeda';

import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';

import { ExpandableMenuItem } from './expandableMenuItem/ExpandableMenuItem';

import css from './BurgerMenu.module.css';

import { userAtom } from 'v2/atoms/userAtom';
import { NAVIGATION_ITEMS } from 'v2/constants/navigationItems';
import { isRouteAllowed } from 'v2/utils';

export const BurgerMenu = memo(() => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const user = useAtomValue(userAtom);

  return (
    isNonNullish(user) && (
      <Fragment>
        <IconButton onClick={setOpen}>
          <Menu color="#ffffff" />
        </IconButton>

        <Drawer open={isOpen} onClose={setOpen}>
          <nav className={css.burgerMenu}>
            {NAVIGATION_ITEMS.map((n) =>
              isNonNullish(n.children) ? (
                <ExpandableMenuItem key={n.title} navigationItem={n} userRoles={user.roles} onClose={setOpen} />
              ) : (
                <Fragment key={n.title}>
                  {isRouteAllowed(user.roles, n.group) && (
                    <NavLink
                      className={({ isActive }) => clsx(css.burgerMenuItem, isActive && css.active)}
                      to={n.path ?? ''}
                      onClick={setOpen}
                    >
                      {createElement(n.icon, { className: css.burgerMenuItemIcon })} {n.title}
                    </NavLink>
                  )}
                </Fragment>
              )
            )}
          </nav>
        </Drawer>
      </Fragment>
    )
  );
});

BurgerMenu.displayName = 'BurgerMenu';
